import useSidepanel from "@hooks/useSidepanel";
import { useEffect } from "react";
import { useCallback } from "react";
import { Row } from "react-table";
import ResourceEditSidepanel from "../components/ResourceEditSidepanel";

export default function useEditAction<R extends ObjectWithId>(options: Modules.Resource.SidepanelOptions<R>) {
    const sidepanel = useSidepanel()

    return useCallback((row: Row<R>) => {
        sidepanel.open(ResourceEditSidepanel, {
            ...options, 
            model: row.original
        })
    }, [options])
}